<template lang="pug">
  WtEntityTable.challenges-table(
    title="My Challenges"
    has-large-title
    :data="challengesData"
    default-sort-field="competition_enddate"
    empty-message="You have not joined any challenges."
    :showEmptyMessage="!loading"
  )
    BTableColumn(field="name" label="Challenge Name" sortable v-slot="column")
      BTooltip(
        label="View this challenge"
        position="is-top"
        animated
      )
        WtRouterLink(
          to="Challenge"
          :params="{ challengeId: column.row.id }"
          :text="column.row.name"
          type="table"
        )
    BTableColumn(field="between" label="Type" sortable  v-slot="column")
      | {{ challengeType(column.row) }}
    BTableColumn(field="startDate" label="Start Date" sortable  v-slot="column")
      | {{ date(column.row.startDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(field="endDate" label="End Date" sortable v-slot="column")
      | {{ date(column.row.endDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(field="status" label="Status" v-slot="column")
      | {{ status(column.row) }}
</template>

<script>
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";

export default {
  name: "MemberChallengesTable",

  components: { WtEntityTable, WtRouterLink },

  mixins: [tablePropsMixin, dateUtilityMixin, challengeMixin],

  props: {
    challengesData: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    status(challenge) {
      const PENDING = 0;
      const ACTIVE = 1;
      const COMPLETED = 2;

      if (challenge.status === PENDING) {
        return "Pending";
      }
      if (challenge.status === ACTIVE) {
        return "Active";
      }
      if (challenge.status === COMPLETED) {
        return "Completed";
      }
    }
  }
};
</script>

<style lang="sass"></style>
